/** Minimum time on the post-login transition screen before advancing. */
export const TRANSITION_MIN_MS = 2000;

/** Time on the sync success state before auto-login redirect. */
export const SYNC_COMPLETE_HOLD_MS = 2000;

export const VIEWS = {
    BOOTSTRAP: 'bootstrap',
    SAGEID_LOGIN: 'sageid_login',
    SAGEID_SUCCESS: 'sageid_success',
    ADMIN_CREATE_FAILED: 'admin_create_failed',
    COMPANIES: 'companies',
    COMPANIES_ERROR: 'companies_error',
    NO_COMPANIES: 'no_companies',
    SYNC_PROGRESS: 'sync_progress',
    SYNC_FAILED: 'sync_failed',
    BLOCKER: 'blocker',
    MOBILE_BLOCKER: 'mobile_blocker',
};

export const SYNC_STEP_IDS = [
    'select_companies',
    'preparing_connection',
    'synchronising_data',
    'completed',
];

/** Number of animated steps shown in the sync progress view. */
export const SYNC_STEP_COUNT = SYNC_STEP_IDS.length;
